var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "contactum-fields" },
    [
      _c("el-input", {
        class: _vm.class_names("textfield"),
        attrs: {
          type: "textarea",
          placeholder: _vm.field.placeholder,
          deault: _vm.field.default,
          rows: _vm.field.rows,
          cols: _vm.field.cols,
          disabled: ""
        }
      }),
      _vm._v(" "),
      _vm.field.help
        ? _c("span", { domProps: { innerHTML: _vm._s(_vm.field.help) } })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }